import React from 'react';
import { TrashBin } from '@gravity-ui/icons';
import { Button, Icon } from '@gravity-ui/uikit';
import { isArrayItem, isArraySpec, isObjectSpec, withGenerateButton, } from '../../../../core';
import { ErrorWrapper, GenerateRandomValueButton } from '../../../components';
import { block } from '../../../utils';
import './Transparent.css';
const b = block('transparent');
export const Transparent = ({ name, spec, input, meta, children, }) => {
    const arrayItem = React.useMemo(() => isArrayItem(name), [name]);
    const generateButton = React.useMemo(() => withGenerateButton(spec), [spec]);
    const arrOrObjFlag = React.useMemo(() => isArraySpec(spec) || isObjectSpec(spec), [spec]);
    const removeButton = React.useMemo(() => {
        if (arrayItem) {
            return (React.createElement(Button, { view: "flat-secondary", className: b('remove-button'), onClick: input.onDrop, qa: `${name}-remove-item` },
                React.createElement(Icon, { data: TrashBin, size: 16 })));
        }
        return null;
    }, [input.onDrop, arrayItem, name]);
    return (React.createElement("div", { className: b({
            'array-item': arrayItem && !arrOrObjFlag,
            'without-max-width': arrOrObjFlag,
        }) },
        React.createElement(ErrorWrapper, { name: name, meta: meta, withoutChildErrorStyles: 
            // TODO: remove condition spec.viewSpec.type !== 'select'
            (isArraySpec(spec) && spec.viewSpec.type !== 'select') || isObjectSpec(spec) }, children),
        generateButton ? (React.createElement(GenerateRandomValueButton, { spec: spec, onChange: input.onChange })) : null,
        removeButton));
};
